import React, {
  memo,
  useImperativeHandle,
  useRef,
} from 'react';

import Chart from '@/pages/dashboard/components/Chart';
import { ChartRef, IProps } from './_type';
import { useOption } from './useOptions';

const LineChart = (props: IProps) => {
  const {
    className = '',
    ref,
    style = {},
    // height,
    notMerge,
    dataSource=[],
    series,
    tooltip,
    expandOption
  } = props;
  const chartRef = useRef<ChartRef>(null);
  const option = useOption({
    dataSource,
    series,
    tooltip,
    expandOption,
  });
  
  // 刷新图表
  const refreshChart = () => {
    instance()?.setOption(option);
  };

  // 获取实例
  const instance = () => chartRef?.current?.instance();

  // 对父组件暴露的方法
  useImperativeHandle(ref, () => ({
    instance,
    refreshChart
  }));

  const chartStyle = {
    width: '100%',
    position: 'relative',
    ...style,
  };

  return (
    <div className={`chart-box ${className}`} style={chartStyle}>
      <Chart
        ref={chartRef}
        option={option}
        notMerge={notMerge}
      />
    </div>
  );
};

const VerticalLineChart = memo(React.forwardRef(LineChart));

export default VerticalLineChart;
